<template>
  <div class="user" v-loading="pageLoading">
    <el-container style="height: 100%">
      <el-aside width="200px">
        <el-menu
          :default-active="active"
          text-color="#000"
          @select="onNavSelected"
          active-text-color="#fff"
          unique-opened
        >
          <el-menu-item
            v-for="i in menuList"
            :key="i.menuUrl"
            :index="i.menuUrl"
          >
            <span slot="title">{{ i.menuName }}</span>
          </el-menu-item>
          <!-- <el-menu-item v-if="userInfo.orgCode != 'FJYFX' && userInfo.schoolCode != 'xueduoduo'"
            v-for="i in menuList"
            :key="i.menuUrl"
            :index="i.menuUrl"
          >
            <span slot="title">{{ i.menuName }}</span>
          </el-menu-item> -->
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="info-box">
          <el-row type="flex" justify="center" align="middle">
            <el-col justify="center">
              <el-avatar
                :size="80"
                :src="userInfo.userLogo ? userInfo.userLogo : userLogo"
              ></el-avatar>
            </el-col>
            <el-col justify="center">
              <div class="txt">
                <h2>{{ userInfo.userName }}</h2>
                <div>
                  <h3>
                    {{
                      teacherInfoList && teacherInfoList.length > 0
                        ? teacherInfoList[0].schoolName
                        : ""
                    }}
                  </h3>
                  <em
                    v-if="gradeDiscipline.length > 0"
                    v-for="(i, index) in gradeDiscipline"
                    :key="index"
                    >{{ i.gradeName }} {{ i.disciplineName }}</em
                  >
                </div>
              </div>
            </el-col>
            <el-col style="flex: 1; display: flex" align="right">
              <el-button
                v-if="
                  (active == 'results' &&
                    power(
                      userInfo.menuInfoList,
                      'userCenter-results-export'
                    )) ||
                  (active == 'plan' &&
                    power(userInfo.menuInfoList, 'userCenter-plan-export'))
                "
                type="primary"
                @click="toExport"
                >导出</el-button
              >
              <el-button type="primary" @click="goInfo">编辑个人信息</el-button>
              <el-button
                type="primary"
                @click="getTemplate"
                v-if="power(userInfo.menuInfoList, 'userInfo-template')"
                >下载模版</el-button
              >
              <export-upload
                v-if="power(userInfo.menuInfoList, 'userInfo-import')"
                @selectLsit="exSelectLsit"
                :urlAction="exUrl"
                :exData="exData"
              ></export-upload>
            </el-col>
          </el-row>
        </el-header>
        <el-main class="main-router">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import ExportUpload from "@/components/ExportUpload.vue";
import { postData } from "@/http/fetch.js";
import { fileSaveZip, power } from "@/utils/index.js";

import { mapGetters, mapState } from "vuex";
export default {
  components: {
    ExportUpload,
  },
  computed: {
    ...mapState(["userInfo", "resOptions"]),
    ...mapGetters(["schoolCodes", "schoolCode"]),
    active() {
      let pathArray = this.$route.path.split("/");
      if (pathArray.length > 0) {
        return pathArray[pathArray.length - 1];
      } else {
        return "plan";
      }
    },
    exData() {
      return {
        operatorId: this.userInfo.userId,
      };
    },
  },
  data() {
    return {
      exUrl: "/user/importXSJTeacherInfo",
      pageLoading: false,
      menuList: [
        {
          menuUrl: "plan",
          menuName: "专业规划",
        },
        {
          menuUrl: "results",
          menuName: "专业成效",
        },
        {
          menuUrl: "space",
          menuName: "个人空间",
        },
        {
          menuUrl: "group",
          menuName: "分组管理",
        },
        {
          menuUrl: "collect",
          menuName: "我的收藏",
        },
      ],
      teacherInfoList: null,
      userLogo: require("@/assets/image/other/man_teacher.png"),
      gradeDiscipline: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    //批量导入成功后
    exSelectLsit() {
      this.$message({
        type: "success",
        message: "导入成功",
      });
      this.init();
    },
    getMenuList() {
      if (this.userInfo.orgCode == "FJYFX") {
        this.menuList = [
          { menuUrl: "plan", menuName: "专业规划" },
          // { menuUrl: "results", menuName: "专业成效" },
          { menuUrl: "space", menuName: "个人空间" },
          // { menuUrl: "group", menuName: "分组管理" },
          { menuUrl: "collect", menuName: "我的收藏" },
          // { menuUrl: "result", menuName: "发展成果" },
          // { menuUrl: "design", menuName: "发展清单" },
        ];
      }
      if (this.userInfo.schoolCode == "fxqdwzx") {
        this.menuList = [
          { menuUrl: "plan", menuName: "专业规划" },
          { menuUrl: "resultscp", menuName: "专业成效" },
          { menuUrl: "space", menuName: "个人空间" },
          // { menuUrl: "group", menuName: "分组管理" },
          { menuUrl: "collect", menuName: "我的收藏" },
        ];
      }
    },
    getTemplate() {
      this.$axios
        .get("/user/downloadXSJTeacherInfoTemplate", {
          responseType: "blob",
        })
        .then((res) => {
          let fileName = window.decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=GBK",
            })
          );
          const download = document.createElement("a");
          download.style.display = "none";
          download.href = url;
          download.setAttribute("download", fileName);
          document.body.appendChild(download);
          download.click();
          document.body.removeChild(download);
          URL.revokeObjectURL(url);
          this.$message({
            message: "下载成功",
            type: "success",
          });
        });
    },
    toExport() {
      if (this.active == "results") {
        this.pageLoading = true;
        this.$axios
          .post(
            "/teacherAwardInfo/exportTeacherHonorAward",
            this.$qs.stringify({
              schoolCodes: this.schoolCodes,
            })
          )
          .then(({ data }) => {
            fileSaveZip(data.url, data.name);
            this.pageLoading = false;
          })
          .catch(() => {
            this.pageLoading = false;
          });
      } else if (this.active == "plan") {
        this.pageLoading = true;
        this.$axios
          .post(
            "/planning/exportPlanningSummary",
            this.$qs.stringify({
              schoolCodes: this.schoolCodes,
            }),
            {
              responseType: "blob",
            }
          )
          .then((res) => {
            this.pageLoading = false;
            let fileName = window.decodeURI(
              res.headers["content-disposition"].split("=")[1]
            );
            const url = URL.createObjectURL(res.data);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName; // 设置下载的文件名
            a.click();
            URL.revokeObjectURL(url);
          })
          .catch(() => {
            this.pageLoading = false;
          });
      }
    },
    power,
    handelGradeDisciplineName() {
      let gdList = [];
      if (
        this.userInfo.teacherDutyList &&
        this.userInfo.teacherDutyList.length > 0
      ) {
        this.userInfo.teacherDutyList.forEach((i) => {
          gdList.push({
            gradeName: i.gradeName,
            disciplineName: i.disciplineName,
          });
        });
      }
      this.teacherInfoList.forEach((i) => {
        gdList.push({
          gradeName: i.gradeName,
          disciplineName: i.disciplineName,
        });
      });
      //数组对象去重
      this.gradeDiscipline = this.unRepeatObject(gdList);
    },
    /**
     * 数组对象去重
     * @param {Array} arr 数组
     * @return {Array} newArr 数组
     */
    unRepeatObject(arr) {
      var tmepArr = [];
      // 将数组对象转成数组字符串
      var newStr = this.changeArrStr(arr);
      newStr.sort();
      // 数组去重
      for (var i = 0; i < newStr.length; i++) {
        if (newStr[i] !== tmepArr[tmepArr.length - 1]) {
          tmepArr.push(newStr[i]);
        }
      }
      var newArr = [];
      // 新数组字符串转成数组对象
      for (var i = 0; i < tmepArr.length; i++) {
        newArr.push(JSON.parse(tmepArr[i]));
      }
      return newArr;
    },

    /**
     * 数组内容对象转成字符串,去空,排序
     * @param {Object} arr
     * @return {Array} newArr
     */
    changeArrStr(arr) {
      var newArr = [];
      if (arr.length !== 0) {
        for (var i = 0; i < arr.length; i++) {
          var thisObj = this.sortObjectFun(arr[i]);
          var thisStr = JSON.stringify(thisObj);
          thisStr = thisStr.replace(/(\s|[\\t])/g, ""); // 去除空格及\t空白字符
          newArr.push(thisStr);
        }
      }
      return newArr;
    },
    /**
     * 对象排序
     * @param {Object} obj
     * @return {Object} newObj
     */
    sortObjectFun(obj) {
      var keyArr = []; // 对象的key
      for (var item in obj) {
        keyArr.push(item);
      }
      keyArr.sort(); // 降序
      var newObj = {};
      for (var i = 0; i < keyArr.length; i++) {
        newObj[keyArr[i]] = obj[keyArr[i]];
      }
      return newObj;
    },
    onNavSelected(index, indexPath) {
      this.$router.push({ name: index });
    },
    async init() {
      let { teacherInfoList } = await postData("/user/getTeacherInfoById", {
        schoolCode: this.userInfo.schoolCode,
        userId: this.userInfo.userId,
      });
      this.teacherInfoList = teacherInfoList;
      this.handelGradeDisciplineName();
      this.getMenuList()
    },
    goInfo() {
      this.$router.push({ name: "info" });
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.user {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  /deep/.el-menu {
    height: 100%;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    margin-right: 5px;
    .el-menu-item {
      height: 50px;
      line-height: 48px;
      border-bottom: 1px solid rgb(228, 218, 218);
    }
    .el-menu-item.is-active {
      color: #fff;
      background-color: @color;
    }
    .el-menu-item:focus,
    .el-menu-item:hover {
      outline: 0;
      color: #fff;
      background-color: @color;
    }
  }
  .info-box {
    min-height: 140px;
    margin-bottom: 15px;
    background-color: #fff;
    padding-bottom: 10px;
    .el-col {
      .el-avatar {
        margin-top: 20px;
        margin-bottom: 20px;
        margin-left: 30px;
      }
      .txt {
        margin-top: 21px;
        margin-left: 25px;
        h2 {
          font-size: 16px;
          color: #000;
          line-height: 35px;
        }
        span {
          font-size: 13px;
          color: rgb(100, 98, 98);
          line-height: 22px;
        }
        span:nth-of-type(1) {
          font-size: 16px;
          color: #000;
          line-height: 35px;
        }
        h3 {
          font-size: 14px;
          height: 30px;
          line-height: 30px;
        }
        em {
          font-size: 13px;
          margin-right: 15px;
        }
      }
    }
    .el-col:nth-child(1) {
      width: 130px;
    }
    .el-col:nth-child(3) {
      width: 630px;
    }
  }
  .main-router {
    padding-top: 0px;
  }
}
</style>
